<template>
  <b-container fluid class="table px-6">
    <b-row>
      <b-col :md="this.isSuperUserDealer() ? 2 : 3">
        <b-form-select id="select-status" v-model="filterOptions.selectedStatus">
          <option :value="null">Все статусы</option>
          <option value="Работает">Работает</option>
          <option value="Просмотр">Просмотр</option>
          <option value="Демо">Демо</option>
          <option value="Приостановлена">Приостановлена</option>
          <option value="В архиве">В архиве</option>
        </b-form-select>
      </b-col>
      <b-col v-if="this.isSuperUserDealer()" md="2" class="pl-0">
        <b-form-select
          id="select-dealer"
          v-model="filterOptions.selectedDealer"
          :options="dealersList"
          value-field="gid"
          text-field="fullname"
        ></b-form-select>
      </b-col>
      <b-col :md="this.isSuperUserDealer() ? 2 : 3" class="pl-0">
        <ctk-date-time-picker
          id="groups-users-datepicker"
          v-model="filterOptions.dateValue"
          label="Дата создания"
          color="#40b539"
          locale="ru"
          range
          :custom-shortcuts="customShortcuts"
          format="YYYY-MM-DD HH:mm"
          formatted="ll"
        >
        </ctk-date-time-picker>
      </b-col>
      <b-col md="3" class="pl-0">
        <b-input-group class="search">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <div class="container_search-close"
               @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </b-input-group>
      </b-col>
      <b-col md="3" class="pr-0">
        <div v-if="!isNotAbleToEditBanGroupsUsers()" class="buttons">
          <b-button v-if="servers.length === 1"
                    class="b-upper"
                    variant="success"
                    @click="companyData({server:servers[0].server_alias}, {add:true})">
            <i class="fas fa-building"></i> Добавить организацию
          </b-button>
          <b-dropdown v-else right class="b-upper" variant="success">
            <template v-slot:button-content>
              <i class="fas fa-building"></i> Добавить организацию
            </template>
            <b-dropdown-item v-for="server in servers"
                             :key="server.server_alias"
                             :disabled="!server.is_success"
                             @click="companyData({server:server.server_alias}, {add:true})">
              {{server.server_name}}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" v-if="servers.length > 1" class="mt-3 mb-1">
        <b-form-group label="Список доступных серверов:">
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="filterOptions.selectedServer"
            :options="servers"
            value-field="server_alias"
            text-field="server_name"
            disabled-field="disabled"
          ></b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4" class="mt-3">
        <div v-if="this.items && this.items.length" class="filtered-items-number mt-3">Записи с
          {{ currentPage === 1 ? this.setFirstItem() : ((currentPage-1)*this.pageOptionSelected)+1 }} до
          {{ this.calcItems() }} из
          {{ this.items.length }} (отфильтровано из
          {{ this.groupsUsers.length }} записей)
        </div>
      </b-col>
      <b-button
        :disabled="loading"
        class="ml-auto mt-3 b-upper"
        @click="downloadFile">Выгрузить в Excel</b-button>
    </b-row>

    <b-table
      hover
      show-empty
      responsive
      @row-clicked="rowToggle"
      id="mytable"
      ref="mytable"
      :fields="fields"
      :items="items"
      :busy.sync="isBusy"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      class="mt-3 blue"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу"
      :sort-compare="sortCompare"
    >

      //organization
      <template v-slot:head(orgname)="data">
        <i class="fas table fa-sitemap"></i> {{ data.label }}
      </template>
      <template v-slot:cell(orgname)="data">
        <div class="td_wrapper">
          <p class="main-name">{{data.item.orgname}}</p>
          <p class="normal">{{data.item.inn_kpp}}</p>
          <div>
            <b-badge :variant="badgeVariant(data.item.access_status)">{{data.item.access_status}}
            </b-badge>
            <b-badge v-if="isSuperUserDealer()">{{data.item.parent}}
            </b-badge>
            <b-badge v-if="servers.length > 1">{{data.item.server_name}}
            </b-badge>
          </div>
        </div>
      </template>

      //info
      <template v-slot:head(info)="data">
        <div class="inline">
          <i class="fas table fa-info-circle"></i> {{ data.label }}
        </div>
      </template>
      <template v-slot:cell(info)="data">
        <div class="td_wrapper">
          <p class="normal">
            <i class="fas table fa-map-marker-alt" v-b-tooltip title="Город"></i>
            {{data.item.city!==null?data.item.city:'Не указан'}}
          </p>
        </div>
      </template>

      //group

      <template v-slot:head(create_date)="data">
        <i class="fas table fa-folder-open"></i> {{ data.label }}
      </template>
      <template v-slot:cell(create_date)="data">
        <div class="td_wrapper">
          <p class="normal bold copy"><i class="fas table fa-users" v-b-tooltip
                                         title="Имя группы Fill-Bill"></i> {{data.item.fb_name}}
            <i class="fas table fa-copy"
               @click="copyToClipboard(data.item.fb_name+data.item.fb_id, $event)"
               :id="data.item.fb_name+data.item.fb_id"
               v-b-tooltip.hover
               title="Копировать"></i>
          </p>
          <p class="normal"><i class="fas table fa-home" v-b-tooltip title="ID группы Fill-Bill"></i>
            {{data.item.fb_id}}</p>
        </div>
        <div class="user_group">
          <p class="normal"><i class="fas table fa-user" v-b-tooltip title="Имя автора"></i>{{data.item.create_user}}
          </p>
          <p class="normal" v-if="data.item.create_date">{{data.item.create_date.split(' ')[0]}}</p>
        </div>
      </template>

      //parameters

      <template v-slot:head(parameters)="data">
        <div class="inline">
          <i class="fas table fa-file-alt"></i> {{ data.label }}
        </div>
      </template>
      <template v-slot:cell(parameters)="data">
        <div class="td_wrapper">
          <div class="inline">
            <div class="icon_ctm" v-b-tooltip title="ID СТМ"></div>
            <p class="normal mb-0 copy">
              {{data.item.ctm_id!==null?data.item.ctm_id:'Не указан'}}
              <i class="fas table fa-copy"
                 v-if="data.item.ctm_id!==null"
                 @click="copyToClipboard('CTMid'+data.item.ctm_id, $event)"
                 :id="'CTMid'+data.item.ctm_id"
                 v-b-tooltip.hover
                 title="Копировать"></i>
            </p>
          </div>
          <p class="normal">
            <i :class="[data.item.participant_id!==''?'fas table fa-monument':'red fas table fa-monument']"
               v-b-tooltip title="ID декларанта"></i>
            {{data.item.participant_id!==''?data.item.participant_id:'Не выбран'}}
          </p>
        </div>
      </template>

      //content

      <template v-slot:head(content)="data">
        <i class="fas table fa-file-alt"></i> {{ data.label }}
      </template>
      <template v-slot:cell(content)="data">
        <div class="td_wrapper">
          <p class="normal"><i class="fas table fa-code-branch"></i> Подгрупп:&nbsp;{{data.item.subgroup_count}}
          </p>
          <p class="normal"><i class="fas table fa-id-card"></i> Пользователей:&nbsp;{{data.item.user_count}}
          </p>
        </div>
      </template>

      //actions

      <template v-slot:head(actions)="data">
        <div class="inline">
          <i class="fas table fa-info-circle"></i> {{ data.label }}
        </div>
      </template>
      <template v-slot:cell(actions)="data">
        <div :class="!isNotAbleToEditBanGroupsUsers() ? 'user-button' : 'remove-user-button'">
          <div class="buttons-holder">
            <div class="buttons-box">
              <b-button v-if="!isNotAbleToEditBanGroupsUsers()" class="b-table" variant="outline-secondary" @click="companyData(data.item, {add:false})"><i
                class="fas fa-pencil-alt"></i></b-button>
              <b-button v-if="!isNotAbleToEditBanGroupsUsers()" class="b-table" variant="outline-secondary" @click="addUser(data.item)"><i
                class="fas fa-user-plus"></i></b-button>
            </div>
          </div>
          <b-button class="more-info"
                    :id="data.item.p_gid +'popover'"><i class="fas table fa-ellipsis-h"></i>
          </b-button>
          <b-popover :target="data.item.p_gid +'popover'"
                     triggers="focus">
            <ul class="popoverButtons">
              <li v-if="!isNotAbleToEditBanGroupsUsers()" @click="companyData(data.item, {add:false})"><i class="fas fa-pencil-alt"></i>
                <span>Изменить организацию</span>
              </li>
              <li v-if="!isNotAbleToEditBanGroupsUsers()" @click="subGroupData(data.item,{add:true})"><i class="fas fa-building"></i>
                <span>Добавить отдел/организацию</span>
              </li>
              <li @click="FCSProfile(data.item, {alias: null})"><i class="fas fa-address-card"></i>
                <span>Профиль ФТС</span>
              </li>
              <li v-if="!isNotAbleToEditBanGroupsUsers()" @click="addUser(data.item)"><i class="fas fa-user-plus"></i>
                <span>Добавить пользователя</span>
              </li>
              <!-- li @click="billingData(data.item)"><i class="fas fa-hand-holding-usd"></i>
                <span>Профиль биллинга</span>
              </li -->
              <li v-if="data.item.access_status=='Приостановлена' || data.item.access_status=='В архиве'"
                  @click="sendToArchive(data.item, $event)">
                <i class="far fa-file-archive"></i>
                <span v-if="data.item.access_status=='Приостановлена'">Добавить в архив</span>
                <span v-else-if="data.item.access_status=='В архиве'">Извлечь из архива</span>
              </li>
            </ul>
          </b-popover>
        </div>
      </template>

      <template v-slot:row-details="data">
        <b-row class="users">
          <b-col md="3" lg="3" xl="3" v-for="(user, index) in data.item.users_json" :key="index"
                 class="p-0 pr-4 pb-4">
            <div :class="userStyle(user)">
              <div class="td_wrapper">
                <div class="user_data">
                  <p class="subgroup bold copy"><i class="fas table fa-user" v-b-tooltip title="Логин"></i> {{user.login}}
                    <i class="fas table fa-copy"
                       @click="copyToClipboard(user.login + user.p_id, $event)"
                       :id="user.login + user.p_id"
                       v-b-tooltip.hover
                       title="Копировать"></i>
                  </p>
                  <i class="fas fa-user-edit user_card_button"
                     v-if="!isNotAbleToEditBanGroupsUsers()"
                     @click="editUser(user, { alias: data.item.server_alias, p_gid: data.item.p_gid, orgname: data.item.orgname, opf: data.item.opf, inn_kpp: data.item.inn_kpp })"
                     v-b-tooltip.hover
                     title="Изменить"></i>
                </div>
                <div class="user_data">
                  <p class="normal"><i class="fas table fa-id-card" v-b-tooltip title="ФИО"></i>
                    {{user.name}}</p>
                </div>
                <div class="user_data">
                  <p class="normal">
                    <i class="fas table fa-user-tag" v-b-tooltip title="Роль"></i>
                    {{user.role}}</p>
                  <p class="normal" v-if="user.selfsign!=='Нет'">
                    <i class="fab table fa-usb mr-0" v-b-tooltip title="Требуется ЭП"></i>
                  </p>
                </div>
                <div v-if="isAbleToAddEmailSettings()" class="user_data">
                  <div class="normal">
                    <i :class="!user.p_notification ? 'fas table fa-envelope opacity' : 'fas table fa-envelope-open-text'"></i>
                    <span :class="!user.p_notification ? 'opacity' : ''">{{!user.p_notification ? 'Без e-mail оповещения' : 'С e-mail оповещением'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-for="group in data.item.subgroups_json" class="user-subgroup" :key="group.name">
          <div :class="[group.class==='active'?'subgroups set-active mb-4':'subgroups mb-4']">
            <div class="subgroup_items">
              <p class="main-name mr-6">Подгруппа: {{group.fullname}}</p>
              <p class="subgroup bold copy mr-6">
                <i class="fas table fa-folder-open" v-b-tooltip title="Имя группы Fill-Bill"></i> {{group.name}}
                <i class="fas table fa-copy"
                   @click="copyToClipboard(group.fullname+group.p_gid, $event)"
                   :id="group.fullname+group.p_gid"
                   v-b-tooltip.hover
                   title="Копировать"></i>
              </p>
              <p class="subgroup bold copy mr-6">
                <i class="fas table fa-home" v-b-tooltip title="ID группы Fill-Bill"></i>{{group.p_gid}}
                <i class="fas table fa-copy"
                   @click="copyToClipboard('tooltip'+group.p_gid, $event)"
                   :id="'tooltip'+group.p_gid"
                   v-b-tooltip.hover
                   title="Копировать"></i>
              </p>
              <p class="subgroup bold" v-show="group.is_org">
                <i :class="[group.participant_id!==''?'fas table fa-monument':'fas table fa-monument red']"
                   v-b-tooltip title="ID декларанта"></i>{{group.participant_id!==''?group.participant_id:'Не выбран'}}
              </p>
            </div>
            <div class="buttons-holder_subgroup">
              <div class="buttons-box">
                <b-button v-if="!isNotAbleToEditBanGroupsUsers()" class="b-table" variant="outline-secondary"
                          @click="subGroupData(group,{add:false, alias: data.item.server_alias})"><i
                  class="fas fa-pencil-alt"></i></b-button>
                <b-button v-if="!isNotAbleToEditBanGroupsUsers()" class="b-table" variant="outline-secondary" @click="addUser(data.item, { subgroup_p_gid: group.p_gid })"><i
                  class="fas fa-user-plus"></i></b-button>
                <b-button v-if="group.is_org" class="b-table" variant="outline-secondary"
                          @click="FCSProfile(group, {alias: data.item.server_alias})"><i
                  class="fas fa-address-card"></i></b-button>
              </div>
            </div>
          </div>

          <b-row class="users">
            <b-col md="4" lg="3" xl="3" v-for="(subuser, index) in group.users" :key="index"
                   class="p-0 pr-4 pb-4">
              <div :class="userStyle(subuser)">
                <div class="td_wrapper">
                  <div class="user_data">
                    <p class="subgroup bold copy"><i class="fas table fa-user" v-b-tooltip title="Логин"></i>
                      {{subuser.login}}
                      <i class="fas table fa-copy"
                         @click="copyToClipboard(subuser.login+subuser.p_id, $event)"
                         :id="subuser.login+subuser.p_id"
                         v-b-tooltip.hover
                         title="Копировать"></i>
                    </p>
                    <div>
                      <i class="fas fa-user-edit user_card_button"
                         v-if="!isNotAbleToEditBanGroupsUsers()"
                         @click="editUser(subuser, { alias: data.item.server_alias, p_gid:data.item.p_gid, subgroup_p_gid: group.p_gid, orgname: group.fullname, opf: group.opf })"
                         v-b-tooltip.hover
                         title="Изменить"></i>
                    </div>
                  </div>
                  <div class="user_data">
                    <p class="normal"><i class="fas table fa-id-card" v-b-tooltip title="ФИО"></i>
                      {{subuser.name}}</p>
                  </div>
                  <div class="user_data">
                    <p class="normal"><i class="fas table fa-user-tag" v-b-tooltip title="Роль"></i>
                      {{subuser.role}}</p>
                    <p class="normal" v-if="subuser.selfsign!=='Нет'"><i class="fab fa-usb mr-0" v-b-tooltip
                                                                         title="Требуется ЭП"></i>
                    </p>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-row>
      </template>
      <template v-slot:table-busy class="text-center text-secondary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Загружаем данные...</strong>
      </template>
    </b-table>

    <div class="main-footer">
      <b-form inline>
        <label class="mr-3">Показать</label>
        <b-form-select :options="pageOptions"
                       v-model="perPage"
                       @change="saveOptionSelected"/>
      </b-form>
      <b-pagination align="center"
                    prev-text="&lt;"
                    first-text="&lt;&lt;"
                    next-text="&gt;"
                    last-text="&gt;&gt;"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-6">
      </b-pagination>
    </div>
    <company :ModData="modalParamsCompany" ref="company">
    </company>
    <user :ModData="modalParamsUser" ref="user">
    </user>
    <fcs-profile :ModData="modalParamsUser" ref="fcsProfile">
    </fcs-profile>
    <sub-group :ModData="modalParamsUser" ref="subGroup">
    </sub-group>
    <billing :ModData="modalParamsUser" ref="billing">
    </billing>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import Company from './modalForms/Company'
import User from './modalForms/User'
import FcsProfile from './modalForms/FCSProfile'
import SubGroup from './modalForms/SubGroup'
import Billing from './modalForms/Billing'
import CtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'groups-users',
  components: {
    CtkDateTimePicker,
    Company,
    User,
    FcsProfile,
    Billing,
    SubGroup
  },
  data () {
    return {
      fields: [
        { key: 'orgname', label: 'Организация', sortable: true },
        { key: 'info', label: 'Информация', sortable: false },
        { key: 'create_date', label: 'Группа', sortable: true },
        { key: 'parameters', label: 'Параметры', sortable: false },
        { key: 'content', label: 'Содержимое', sortable: false },
        { key: 'actions', label: 'Действия', sortable: false }
      ],
      items: null,
      // filterStatus: [],
      // filterData: [],
      currentPage: 1,
      totalRows: null,
      perPage: 5,
      pageOptions: [5, 10, 20, 50],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      // selectedStatus: null,
      confirm: '',
      item: {},
      id: null,
      onclickColor: 'gray',
      // dateValue: {'start': null, 'end': null},
      customShortcuts: [
        { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
        { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
        { key: 'thisYear', label: 'Этот год', value: 'year' }
      ],
      day: null,
      month: null,
      year: null,
      hours: null,
      minutes: null,
      modalData: null,
      pageOptionSelected: 10,
      loading: false,
      // selectedServer: null,
      filterOptions: {
        selectedServer: [],
        dateValue: { start: '', end: '' },
        selectedStatus: null,
        selectedDealer: null
      }
    }
  },

  watch: {
    items () {
      this.totalRows = this.items.length
    },
    dealers () {
      this.itemsTable = JSON.parse(JSON.stringify(this.dealers))
      this.items = this.itemsTable
    },
    groupsUsers () {
      this.itemsTable = JSON.parse(JSON.stringify(this.groupsUsers))
      this.items = this.itemsTable
      // if (this.filterStatus.length !== 0 || this.filterData.length !== 0) {
      //     this.itemsTable = JSON.parse(JSON.stringify(this.groupsUsers));
      //     this.items = this.itemsTable;
      //     this.filtrationStatus(this.selectedStatus);
      //     if (this.dateValue === null) {
      //         this.filtrationDate(new Date(2011, 0, 1, 0, 0), new Date());
      //     }
      //     else if (this.dateValue.start !== '' && this.dateValue.end !== '') {
      //         this.filtrationDate(new Date(this.dateValue.start), new Date(this.dateValue.end));
      //     }
      // }
      // else {
      //
      // }
    },
    filterOptions: {
      handler: function () {
        this.items = this.itemsTable.filter(item => {
          return this.filterStatuses(item) && this.filterServers(item) && this.filterDate(item) && this.filterDealers(item)
        })
      },
      deep: true
    }
    // selectedStatus() {
    //     this.filtrationStatus(this.selectedStatus);
    // },
    // dateValue() {
    //     if (this.dateValue === null) {
    //         this.filtrationDate(new Date(2011, 0, 1, 0, 0), new Date());
    //     }
    //     else if (this.dateValue.start !== '' && this.dateValue.end !== '') {
    //         this.filtrationDate(new Date(this.dateValue.start), new Date(this.dateValue.end));
    //     }
    // }
  },
  mounted () {
    if (this.isSuperUserDealer()) {
      this.getAllDealers()
      this.getAllDealersGroups()
        .then(
          () => {
            this.items = JSON.parse(JSON.stringify(this.groupsUsers))
          }
        )
    } else {
      this.getGroupsUsers()
        .then(
          () => {
            this.items = JSON.parse(JSON.stringify(this.groupsUsers))
          }
        )
    }
  },
  methods: {
    isAbleToAddEmailSettings () {
      const hasRights = this.userInfo.rights.user.filter(item => {
        return item === 'email_settings'
      })
      return (hasRights.length > 0)
    },
    isSuperUserDealer () {
      const hasRights = this.userInfo.rights.user.filter(item => {
        return item === 'dealer_users'
      })
      return (hasRights.length > 0)
    },
    isNotAbleToEditBanGroupsUsers () {
      const hasRights = this.userInfo.rights.user.filter(item => {
        return item === 'edit_ban_users_groups'
      })
      return (hasRights.length > 0)
    },
    filterStatuses (item) {
      if (this.filterOptions.selectedStatus !== null) {
        return item.access_status === this.filterOptions.selectedStatus
      } else {
        return this.itemsTable
      }
    },
    filterServers (item) {
      if (this.filterOptions.selectedServer.length > 0) {
        return this.filterOptions.selectedServer.includes(item.server_alias)
      } else {
        return this.itemsTable
      }
    },
    filterDealers (item) {
      if (this.filterOptions.selectedDealer !== null) {
        // console.log('item.parent_id ', item.parent_id)
        // console.log('this.filterOptions.selectedDealer ', this.filterOptions.selectedDealer)
        return item.parent_id === this.filterOptions.selectedDealer
      } else {
        return this.itemsTable
      }
    },
    filterDate (item) {
      let dCreate = item.create_date.split(' ')
      const justDate = dCreate[0].split('.');
      [justDate[0], justDate[2]] = [justDate[2], justDate[0]]
      dCreate[0] = justDate.join('-')
      dCreate = dCreate.join(' ')
      if (this.filterOptions.dateValue !== null && this.filterOptions.dateValue.start !== '' && this.filterOptions.dateValue.end !== '') {
        return new Date(Date.parse(dCreate)) >= new Date(Date.parse(this.filterOptions.dateValue.start)) &&
          new Date(Date.parse(dCreate)) <= new Date(Date.parse(this.filterOptions.dateValue.end))
      } else {
        return this.itemsTable
      }
    },
    // saveToLocalStorage() {
    //     localStorage.selectedStatus = this.filterOptions.selectedStatus;
    // },
    badgeVariant (data) {
      if (data === 'Работает') {
        return 'success'
      } else if (data === 'Просмотр') {
        return 'info'
      } else if (data === 'Приостановлена') {
        return 'danger'
      } else if (data === 'Демо') {
        return 'warning'
      } else if (data === 'В архиве') {
        return 'secondary'
      }
    },
    clearField () {
      this.filter = ''
    },
    userStyle (user) {
      if (user.class === 'active') {
        return 'user_card set-active'
      } else if (user.role === 'Banned users') {
        return 'user_card opacity'
      } else {
        return 'user_card'
      }
    },
    rowToggle (row, index, event) {
      if (row._showDetails !== true && event.target.nodeName !== 'p') {
        Vue.set(row, '_showDetails', true)
      } else if (row._showDetails === true) {
        Vue.set(row, '_showDetails', false)
      }
    },
    copyToClipboard (id, e) {
      const self = this
      e.stopPropagation()
      const copyedText = e.target.parentNode.outerText
      var textArea = document.createElement('textarea')
      textArea.value = copyedText
      document.body.appendChild(textArea)
      textArea.select()
      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        self.$root.$emit('bv::hide::tooltip', id)
        e.target.setAttribute('data-original-title', 'Скопировано')
        e.target.setAttribute('style', 'color:#40b539')
        self.$root.$emit('bv::show::tooltip', id)
        setTimeout(function () {
          e.target.setAttribute('data-original-title', 'Копировать')
          e.target.setAttribute('style', 'color:#78909C')
        }, 1500)
        console.log('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }
      document.body.removeChild(textArea)
    },
    //
    //
    // filtrationStatus(selectedStatus) {
    //     if(this.itemsTable!==undefined){
    //         this.items = this.itemsTable.filter(function (item) {
    //             if (selectedStatus !== null) {
    //                 return item.access_status === selectedStatus;
    //             }
    //             else {
    //                 return item;
    //             }
    //         });
    //         this.filterStatus = this.items;
    //         this.totalRows = this.items.length
    //         this.currentPage= 1;
    //         this.compare();
    //     }
    // },
    // filtrationDate(dStart, dEnd) {
    //     let self = this;
    //     this.items = this.itemsTable.filter(function (item) {
    //         self.parseDate(item.create_date);
    //         let dCreate = new Date(self.year, self.month, self.day, self.hours, self.minutes);
    //         return dCreate >= dStart && dCreate <= dEnd;
    //     });
    //     this.filterData = this.items;
    //     this.totalRows = this.items.length;
    //     this.currentPage= 1;
    //     this.compare();
    //
    // },
    // parseDate(date) {
    //     let dateTime = date.split(' ');
    //     let data = dateTime[0].split('.');
    //     let time = dateTime[1].split(':');
    //     this.day = data[0];
    //     this.month = data[1] - 1;
    //     this.year = data[2];
    //     this.hours = time[0];
    //     this.minutes = time[1];
    // },
    // compare() {
    //     const fullItems = [];
    //     if (this.filterStatus.length !== 0 && this.filterData.length !== 0) {
    //         this.filterStatus.forEach((e1) => this.filterData.forEach((e2) => {
    //             if (e1.p_gid === e2.p_gid) {
    //                 fullItems.push(e1);
    //             }
    //         }))
    //     }
    // },
    sortCompare (aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
      const a = aRow[key]
      const b = bRow[key]
      if (key === 'create_date') {
        const c = this.toDate(a)
        const d = this.toDate(b)
        return c < d ? 1 : c > d ? -1 : 0
      }
      if (key === 'orgname') {
        return this.toStr(a).localeCompare(this.toStr(b), compareLocale, compareOptions)
      }
    },
    toDate (date) {
      const dateTime = date.split(' ')
      const data = dateTime[0].split('.')
      const time = dateTime[1].split(':')
      const day = data[0]
      const month = data[1] - 1
      const year = data[2]
      const hours = time[0]
      const minutes = time[1]
      return new Date(year, month, day, hours, minutes)
    },
    toStr (value) {
      if (value === null || typeof value === 'undefined') {
        return ''
      } else if (value instanceof Object) {
        return Object.keys(value).sort().map(key => toString(value[key])).join(' ')
      } else {
        return String(value)
      }
    },
    setFirstItem () {
      if (this.items.length < 1) {
        return 0
      } else {
        return 1
      }
    },
    saveOptionSelected (event) {
      this.pageOptionSelected = event
    },
    calcItems () {
      if (this.currentPage === 1) {
        if ((this.currentPage) + this.pageOptionSelected < this.items.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.items.length
        }
      } else {
        if (((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected < this.items.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.items.length
        }
      }
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    companyData (data, add) {
      const dataAdd = data
      dataAdd.add = add.add
      this.$refs.company.modalCompany(dataAdd)
    },
    addUser (user, options) {
      const userData = JSON.parse(JSON.stringify(user))
      userData.add = true
      if (options) {
        const isSubgroupUser = Object.keys(options).indexOf('subgroup_p_gid')
        if (isSubgroupUser !== -1) {
          userData.subgroup_p_gid = options.subgroup_p_gid
        } else {
          userData.subgroup_p_gid = null
        }
      }
      this.$refs.user.modalUser(userData)
    },
    editUser (user, options) {
      const userData = JSON.parse(JSON.stringify(user))
      userData.add = false
      userData.alias = options.alias
      userData.p_gid = options.p_gid
      userData.orgname = options.orgname
      userData.opf = options.opf
      userData.inn_kpp = options.inn_kpp
      const isSubgroupUser = Object.keys(options).indexOf('subgroup_p_gid')
      if (isSubgroupUser !== -1) {
        userData.subgroup_p_gid = options.subgroup_p_gid
      } else {
        userData.subgroup_p_gid = null
      }
      this.$refs.user.modalUser(userData)
    },
    FCSProfile (data, alias) {
      const dataSend = data
      if (alias.alias !== null) {
        dataSend.alias = alias.alias
        this.$refs.fcsProfile.modalSubgroupFCS(dataSend)
      } else {
        this.$refs.fcsProfile.modalGroupFCS(dataSend)
      }
    },
    subGroupData (data, add) {
      const dataAdd = data
      dataAdd.add = add.add
      if (!add.add) {
        dataAdd.alias = add.alias
      }
      this.$refs.subGroup.modalSubgroup(dataAdd)
    },
    billingData (data) {
      this.$refs.billing.modalBilling(data)
    },
    sendToArchive (row) {
      this.sendToArchive(row)
      this.$root.$emit('bv::hide::popover', row.p_gid + 'popover')
    },
    ...mapActions('groupsUsers', [
      'getGroupsUsers',
      'sendToArchive',
      'getAllDealersGroups',
      'getAllDealers',
      'downloadExcelFile'
    ]),
    downloadFile () {
      this.loading = true
      this.downloadExcelFile(this.selectedServer).then(
        (result) => {
          const fileName = 'organisations_users.xlsx'
          const downloadUrl = window.URL.createObjectURL(new Blob([result.data]))
          const link = document.createElement('a')
          link.href = downloadUrl
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          URL.revokeObjectURL(downloadUrl)
          this.$nextTick(() => {
            this.loading = false
          })
        },
        (error) => {
          this.loading = false
          console.log(error)
        }
      )
    }
  },
  computed: {
    ...mapState(
      {
        groupsUsers: state => state.groupsUsers.groupsUsers,
        servers: state => state.groupsUsers.servers,
        modalParamsCompany: state => state.groupsUsers.modalParamsCompany,
        modalParamsUser: state => state.groupsUsers.modalParamsUser,
        isBusy: state => state.groupsUsers.isBusy,
        dealers: state => state.groupsUsers.dealers,
        dealersList: state => state.groupsUsers.dealersList,
        userInfo: state => state.authorization.userInfo
      }
    )
  }
}
</script>

<style scoped>
  .table.red {
    color: #e7161a;
  }

  .container_search-close {
    position: absolute;
    right: 11px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
  }

  .container_search-close:hover {
    border-radius: 50%;
    background-color: #acacac;
  }

  .search-close {
    font-size: 18px;
    color: #acacac;
    cursor: pointer;
    line-height: 18px;
    width: 18px;
    text-align: center;
    margin-bottom: 2px;
  }

  .container_search-close:hover > span {
    color: #fff;
  }

  #select-status, #select-dealer {
    font-size: 14px;
    height: 40px;
  }

  .opacity {
    opacity: 0.6;
  }

  .popover.popover-body {
    padding: 0;
  }

  .qwerty {
    display: flex;
    flex-direction: column;
  }

  p.copy:hover i.fa-copy {
    visibility: visible;
  }

  i.fa-copy {
    visibility: hidden;
    margin: 0;
  }

  .buttons-holder {
    display: flex;
    visibility: hidden;
  }

  button.b-table {
    padding: 0.1rem 0.375rem;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-right: 0.75rem;
    border: 2px solid #cfd8dc;
  }

  button.b-table:hover {
    color: #fff;
  }

  tr:hover .buttons-holder, .b-table-has-details .buttons-holder {
    visibility: visible;
  }

  .buttons-holder_subgroup {
    display: flex;
    visibility: hidden;
  }

  .subgroups:hover .buttons-holder_subgroup {
    visibility: visible;
  }

  .table .table {
    background-color: unset;
  }

  .user_card_button {
    font-size: 16px;
    color: #78909C;
    margin-right: 0;
    visibility: hidden;
  }

  .user_card_button:hover {
    color: #37474F;
  }

  .user_card:hover .user_card_button {
    visibility: visible;
  }

  .more-info {
    display: flex;
    align-items: center;
    background-color: unset;
    padding: 0;
    margin: 0;
    border: none;
    box-shadow: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    padding: 0.1rem 0.375rem;
  }

  .more-info > .table {
    font-size: 20px;
  }

  .btn-secondary:not(:disabled):not(.disabled):active:focus {
    /*box-shadow: none;*/
  }

  .btn-secondary:not(:disabled):not(.disabled):active {
    background-color: #Fff;
  }

  select {
    -webkit-appearance: none;
    cursor: pointer;
  }

  .td_wrapper {
    display: flex;
    flex-direction: column;
  }

  i.table {
    width: 20px;
    height: 20px;
    color: #78909C;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin-right: 8px;
  }

  i.fa-search {
    width: 36px;
    height: 36px;
  }

  p.main-name {
    color: #37474F;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    margin-bottom: 0;
  }

  p.normal {
    color: #37474F;
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 16px;
    display: inline-flex;
    align-items: baseline;
    margin-bottom: 8px;
  }

  p.subgroup {
    display: inline-flex;
    color: #37474F;
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 16px;
    margin-bottom: 0;
    align-items: baseline;
    word-break: break-all;
  }

  .bold {
    font-weight: bold;
  }

  .users {
    margin: 0;
  }

  .inline {
    display: inline-flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .b-table {
    padding: 0.275rem;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-right: 0.75rem;
    border: 2px solid #cfd8dc;
    color: #78909c;
  }

  .btn.b-table:hover i {
    color: #fff;
  }

  .user_data {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    /*flex-wrap: wrap;*/
  }

  .user_group {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    flex-wrap: wrap;
  }

  .icon_ctm {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    background-color: #78909C;
    -webkit-mask: url("../assets/icon-ctm.svg") no-repeat center;
    mask: url("../assets/icon-ctm.svg") no-repeat center;
  }

  .user_card {
    height: 100%;
    padding: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  }

  .user_card:hover {
    cursor: pointer;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
  }

  .user-subgroup {
    display: flex;
    flex-direction: column;
    margin: 0;
    flex-wrap: nowrap;
    /*border: 4px solid #CFD8DC;*/
  }

  .subgroups {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 6px 15px;
    margin: 0 -15px;
    background-color: #F5F7F8;
    min-height: 44px;
  }

  .set-active {
    background-color: #c3e6cb;
  }

  .subgroup_items {
    display: inline-flex;
    align-items: center;
  }

  .cards .card {
    margin: 5px;
  }

  .custom-select {
    font-size: 12px;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
  }

  .user-button {
    display: flex;
    justify-content: flex-start;
  }

  .remove-user-button {
    display: flex;
    justify-content: flex-end;
  }

  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .table {
    margin-bottom: 0;
  }

  #mytable {
    width: 100%;
    table-layout: fixed;
  }

  .wrap {
    display: flex;
    justify-content: flex-end;
  }

  table.b-table > thead > tr > th.sorting::after, table.b-table > tfoot > tr > th.sorting::after {
    right: 0.75em;
  }

  ul.rights {
    padding: 0;
  }

  .input-group > .form-control:not(:last-child), .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    font-size: 14px;
    height: 40px;
  }

  .input-group i {

    right: 0px;
    position: absolute;
    pointer-events: none;
    padding: 10px;
    z-index: 99;
    color: #9ba3a7;
  }

  li.rights {
    list-style: none;
    border: #37474F 1px solid;
    background-color: #546E7A;
    margin: 5px;
    padding: 5px;
    border-radius: 5px;
    color: #ffffff;
    text-align: center;
  }

  .buttons-box {
    display: flex;
  }

  ul.popoverButtons {
    list-style: none;
    cursor: pointer;
    margin-right: 0rem;
    border: none;
    color: #78909c;
    margin-bottom: 0;
    padding-inline-start: 0;
    width: 100%;
  }

  ul.popoverButtons > li {
    padding: 9px;
  }

  ul.popoverButtons > li:not(:last-child) {
    padding: 9px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  ul.popoverButtons > li > span {
    font-size: 14px;
    line-height: 20px;
    color: #37474F;
  }

  ul.popoverButtons > li > i {
    height: 24px;
    width: 24px;
    font-size: 16px;
    text-align: center;
    margin-right: 4px;
  }

  ul.popoverButtons > li:hover {
    padding: 9px;
    background-color: #ECEFF1;
  }

  .b-upper {
    margin-right: 1rem;
  }

  .buttons-holder_subgroup {
    display: flex;
    visibility: hidden;
  }

  .subgroups:hover .buttons-holder_subgroup {
    visibility: visible;
  }

  .filtered-items-number {
    font-size: 14px;
  }
</style>
